// Generated by CoffeeScript 2.7.0
var TryItParent;

TryItParent = TryItParent || {};

TryItParent.namespace = function(ns) {
  var i, parent, parts;
  parts = ns.split('.');
  parent = TryItParent;
  i = void 0;
  if (parts[0] === 'TryItParent') {
    parts = parts.slice(1);
  }
  i = 0;
  while (i < parts.length) {
    if (typeof parent[parts[i]] === 'undefined') {
      parent[parts[i]] = {};
    }
    parent = parent[parts[i]];
    i += 1;
  }
  return parent;
};

window.TryItParent = TryItParent;
